module.exports = __webpack_public_path__ + "img/banner.3e362a44.png";